module.exports = __webpack_public_path__ + "static/media/chevron-down.afc4b52f.svg";